import moment, { Moment } from 'moment';
import { RECOMMENDATION_TIMING } from 'src/contexts/assistant/constants';
import { TRecommendation } from 'src/modules/assistant/types/message';
import { getRecommendationTiming } from './recommendationActions';

const NOW_OFFSET_MINUTES = 10;
const TODAY_OFFSET_HOURS = 2;
const THIS_WEEK_OFFSET_DAYS = 3;
const DEFAULT_OFFSET_DAYS = 1;
const MORNING_HOUR = 10;

const atMorning = (date: Moment) => date.hour(MORNING_HOUR).minute(0);

/**
 * Suggested date for a task or appointment created from a recommendation,
 * based on how urgent the recommendation is.
 */
export const getRecommendationScheduledAt = (
    recommendation: TRecommendation,
    now: Moment = moment()
): string => {
    const date = now.clone();
    const timing = getRecommendationTiming(recommendation);
    if (timing === RECOMMENDATION_TIMING.NOW)
        return date.add(NOW_OFFSET_MINUTES, 'minutes').format();
    if (timing === RECOMMENDATION_TIMING.TODAY)
        return date.add(TODAY_OFFSET_HOURS, 'hours').format();
    if (timing === RECOMMENDATION_TIMING.THIS_WEEK)
        return atMorning(date.add(THIS_WEEK_OFFSET_DAYS, 'days')).format();
    return atMorning(date.add(DEFAULT_OFFSET_DAYS, 'day')).format();
};
